import BaseRequest from "./BaseRequest";
import { API_URL } from "../config/config";
import { logSecurityEvent } from '../security/apiPathSecurity';

const AuthRequest = () => {
    return {
        login(username, password, recaptchaToken) {
            // Basic input validation for security
            if (!username || typeof username !== 'string' || username.trim().length === 0) {
                logSecurityEvent('invalid_username', { providedUsername: String(username || 'empty') });
                return Promise.reject(new Error('Invalid username provided'));
            }

            if (!password || typeof password !== 'string' || password.length === 0) {
                // logSecurityEvent('invalid_password', { passwordLength: password ? password.length : 0 });
                return Promise.reject(new Error('Invalid password provided'));
            }

            let requestData = {
                // grant_type: 'password',
                // client_secret: process.env.REACT_APP_PASSWORD_CLIENT_SECRET,
                // client_id: process.env.REACT_APP_PASSWORD_CLIENT_ID,
                // scope: '',
                username: username.trim(),
                password,
                // refresh_token: this.refreshToken()
            };

            if (recaptchaToken) {
                // Validate recaptcha token format if provided
                if (typeof recaptchaToken !== 'string' || recaptchaToken.trim().length === 0) {
                    logSecurityEvent('invalid_recaptcha_token', { providedToken: 'invalid_format' });
                    return Promise.reject(new Error('Invalid recaptcha token provided'));
                }
                
                requestData = {
                    ...requestData,
                    recaptcha_token: recaptchaToken.trim()
                };
            }

            // Use secure path construction to prevent SSRF
            // const secureOAuthPath = '/oauth/token';
            const secureOAuthPath = '/api/login';
            
            return BaseRequest.axiosInst.post(
                secureOAuthPath,
                requestData,
                { headers: {lang: BaseRequest.language}}
            );
        },
        getUserData(authToken = null) {
            let headers = authToken
                ? {
                    Authorization: `Bearer ${authToken.credentials.token}`
                }
                : BaseRequest.publicHeaders;

            headers = {
                ...headers,
                lang: BaseRequest.language
            }
            
            const securePessoasPath = API_URL + '/pessoas/auth-summary';

            return BaseRequest.axiosInst.get(securePessoasPath, {
                headers
            });
        },
        refreshToken() { },
        gerarAutenticacaoOIDC(login, redirect) {
            // Validate login parameter
            if (login && (typeof login !== 'string' || login.trim().length === 0)) {
                logSecurityEvent('invalid_oidc_login', { providedLogin: String(login) });
                return Promise.reject(new Error('Invalid login parameter provided'));
            }

            // Validate redirect parameter
            if (redirect && typeof redirect !== 'string') {
                logSecurityEvent('invalid_oidc_redirect', { providedRedirect: String(redirect) });
                return Promise.reject(new Error('Invalid redirect parameter provided'));
            }

            // Build secure OIDC authorize path
            const secureOidcPath = API_URL + '/oidc/authorize';

            return BaseRequest.axiosInst.get(
                secureOidcPath,
                {
                    params: { 
                        login: login ? login.trim() : undefined, 
                        redirect: redirect ? redirect.trim() : undefined 
                    },
                    headers: BaseRequest.publicHeaders
                }
            );
        },
        validarAutenticacaoOIDC(nonce) {
            // Validate nonce parameter
            if (!nonce || typeof nonce !== 'string' || nonce.trim().length === 0) {
                logSecurityEvent('invalid_oidc_nonce', { providedNonce: String(nonce || 'empty') });
                return Promise.reject(new Error('Invalid nonce parameter provided'));
            }

            // Build secure OIDC validation path
            const secureOidcValidationPath = API_URL + '/oidc/validar';

            return BaseRequest.axiosInst.post(
                secureOidcValidationPath,
                { nonce: nonce.trim() },
                { headers: BaseRequest.publicHeaders }
            );
        },
        insertNounceForValidationOIDC(code,state) {
            if (!code || typeof code !== 'string' || code.trim().length === 0) {
                logSecurityEvent('invalid_oidc_code', { providedCode: String(code || 'empty') });
                return Promise.reject(new Error('Invalid code parameter provided'));
            }

            const secureOidcValidationPath = API_URL + '/oidc/token_nounce';

            return BaseRequest.axiosInst.post(
                secureOidcValidationPath,
                { code: code, 
                  state: state 
                },
                { headers: BaseRequest.publicHeaders }
            );
        },
        gerarAutenticacaoSaml(redirect) {
            // Validate redirect parameter
            if (redirect && typeof redirect !== 'string') {
                logSecurityEvent('invalid_saml_redirect', { providedRedirect: String(redirect) });
                return Promise.reject(new Error('Invalid redirect parameter provided'));
            }

            // Build secure SAML login path
            const secureSamlLoginPath = API_URL + '/saml/login';

            return BaseRequest.axiosInst.get(
                secureSamlLoginPath,
                {
                    params: { redirect: redirect ? redirect.trim() : undefined },
                    headers: BaseRequest.publicHeaders
                }
            );
        },
        validarAutenticacaoSaml(saml) {
            // Validate SAML data
            if (!saml || (typeof saml !== 'string' && typeof saml !== 'object')) {
                logSecurityEvent('invalid_saml_data', { providedSaml: String(saml || 'empty') });
                return Promise.reject(new Error('Invalid SAML data provided'));
            }

            // Build secure SAML validation path
            const secureSamlValidationPath = API_URL + '/saml/validar';

            return BaseRequest.axiosInst.post(
                secureSamlValidationPath,
                { saml },
                { headers: BaseRequest.publicHeaders }
            );
        },
    };
};

export default AuthRequest();
